module.exports = __webpack_public_path__ + "img/sql.bdc3e359.png";